var scope_0 = require('/home/runner/work/leaflet-geosearch/leaflet-geosearch/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/37ab5067ca5e4106f9e9ee5237ac4a92.js').default;

var scope_1 = require('/home/runner/work/leaflet-geosearch/leaflet-geosearch/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4eab0ff88b6ffbfc39f10407d6e7e409.js').default;

var scope_2 = require('/home/runner/work/leaflet-geosearch/leaflet-geosearch/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/56bb365edd64675e7d61439107407f86.js').default;

var scope_3 = require('/home/runner/work/leaflet-geosearch/leaflet-geosearch/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/97d3c7e8ef5800db0bbb8f73236a2d97.js').default;

var scope_4 = require('/home/runner/work/leaflet-geosearch/leaflet-geosearch/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;

var __DOCZ_DUMMY_EXPORT_DEFAULT = Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4);

export default __DOCZ_DUMMY_EXPORT_DEFAULT;

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !Object.prototype.hasOwnProperty.call(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !Object.prototype.hasOwnProperty.call(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}